module.exports = __webpack_public_path__ + "img/multipubblicazione.28addaac.svg";